(() => {
  if (window.vjCookiePreferencesBound) return;
  window.vjCookiePreferencesBound = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-vj-cookie-preferences]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') return;
    event.preventDefault();
    Promise.resolve().then(() => banner.showPreferences()).catch(() => {
      window.location.assign(link.href);
    });
  });
})();
